import React from 'react';
import LabelsTable from './LabelsTable';
import 'views/components/InfoPanel/children/TableStyles.scss';
import QuickAdd from './QuickAdd';

const IconsAndLabels = ({ metro, phaseId, projectId }) => {
  return (
    <div className="content-view">
      <div className="content-section">
        <LabelsTable metro={metro} phaseId={phaseId} projectId={projectId} />
        <QuickAdd metro={metro} phaseId={phaseId} />
      </div>
    </div>
  );
};

export default IconsAndLabels;
